import { ISMT_NhomDeThiIn_Request } from "../../../model/request/de-thi/de-thi-in/ISMT_NhomDeThiIn_Request";
import { ISMT_NhomDeThiIn } from "../../../model/respone/de-thi/ISMT_NhomDeThiIn";
import { apiClient } from "../../apiClient";

export const NHOM_DE_THI_IN_ENDPOINT = "nhom-de-thi-in";
export const nhomDeThiInApi = {
  Select: (payload: ISMT_NhomDeThiIn) =>
    apiClient.get(`${NHOM_DE_THI_IN_ENDPOINT}`),
  SelectByHeMon: (payload: ISMT_NhomDeThiIn_Request) =>
    apiClient.get(
      `${NHOM_DE_THI_IN_ENDPOINT}/by-he-mon/${payload.id_he}/${payload.id_bm}/${payload.id_mon}`
    ),
  SelectById: (id: number) => apiClient.get(`${NHOM_DE_THI_IN_ENDPOINT}/${id}`),
  Insert: (payload: ISMT_NhomDeThiIn) =>
    apiClient.post(`${NHOM_DE_THI_IN_ENDPOINT}`, payload),
  Update: (payload: ISMT_NhomDeThiIn) =>
    apiClient.put(`${NHOM_DE_THI_IN_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${NHOM_DE_THI_IN_ENDPOINT}/${id}`),
  DeleteMultiple: (ids: number[]) =>
    apiClient.put(`${NHOM_DE_THI_IN_ENDPOINT}/delete-multiple`, ids),
};
